import * as base64Buffer from "base64-arraybuffer";

//Start of frame
const SOH = 0x01;

//End of frame
const EOT = 0x04;

//Data link escape
const DLE = 0x10;

export function getPayload(array: Uint8Array): Uint8Array {
  const payloadIndices: number[] = [];

  let skipNexControlByte = false;

  for (let i = 1; i < array.length - 1; i++) {
    const uInt = array[i];
    if (skipNexControlByte) {
      payloadIndices.push(i);
      skipNexControlByte = false;
    } else {
      if (uInt === DLE) {
        skipNexControlByte = true;
      } else {
        payloadIndices.push(i);
      }
    }
  }

  const result = new Uint8Array(payloadIndices.length);
  let resultIndex = 0;

  for (const index of payloadIndices) {
    result[resultIndex++] = array[index];
  }

  return result;
}

export function extractPayload(base64String: string): Uint8Array {
  return getPayload(new Uint8Array(base64Buffer.decode(base64String)));
}
function addAndEscape(toAdd: number, target: Array<number>) {
  if (toAdd === EOT || toAdd === SOH || toAdd === DLE) {
    target.push(DLE);
  }

  target.push(toAdd);
}

function calculateCrc16(data: Uint8Array): number {
  let result = 0;

  for (const d of data) {
    result = ((result >>> 8) | (result << 8)) & 0xffff;
    result ^= d & 0xff;
    result ^= (result & 0xff) >> 4;
    result ^= (result << 12) & 0xffff;
    result ^= ((result & 0xff) << 5) & 0xffff;
  }

  result &= 0xffff;

  return result;
}

export function buildIresDeviceFrame(payload: Uint8Array): string {
  const crc16 = calculateCrc16(payload);

  const dataWithControlChars: Array<number> = [];

  for (const uint8 of payload) {
    addAndEscape(uint8, dataWithControlChars);
  }

  const crcLower = crc16 & 0xff;
  const crcUpper = (crc16 >> 8) & 0xff;

  addAndEscape(crcLower, dataWithControlChars);
  addAndEscape(crcUpper, dataWithControlChars);

  const result = new Uint8Array(
    dataWithControlChars.length + 2 /* SOH + EOT */
  );

  result[0] = SOH;

  dataWithControlChars.forEach((item, index) => {
    result[1 + index] = item;
  });

  result[result.length - 1] = EOT;

  return base64Buffer.encode(result);
}
